import { render } from "./ComplianceCompany.vue?vue&type=template&id=03845194&scoped=true"
import script from "./ComplianceCompany.vue?vue&type=script&lang=js"
export * from "./ComplianceCompany.vue?vue&type=script&lang=js"

import "./ComplianceCompany.vue?vue&type=style&index=0&id=03845194&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03845194"]])

export default __exports__